<dialog #dialog class="cdlg" aria-labelledby="cdlg-title" aria-describedby="cdlg-message"
        (cancel)="onCancel($event)" (keydown.escape)="onCancel($event)" (click)="onClick($event)">
  @if (request(); as r) {
    <div class="cdlg__card" [class.cdlg__card--danger]="r.tone === 'danger'">
      <h2 id="cdlg-title" class="cdlg__title">{{ r.title }}</h2>
      <p id="cdlg-message" class="cdlg__message">{{ r.message }}</p>
      <div class="cdlg__actions">
        <button type="button" class="btn btn--ghost btn--sm" data-autofocus (click)="answer(false)">
          <span>{{ r.cancelLabel ?? 'Cancel' }}</span>
        </button>
        <button type="button" class="btn btn--sm"
                [class.btn--primary]="r.tone !== 'danger'"
                [class.btn--danger]="r.tone === 'danger'"
                (click)="answer(true)">
          <span>{{ r.confirmLabel ?? 'Confirm' }}</span>
        </button>
      </div>
    </div>
  }
</dialog>
